export function percentChanged(
  currentNumber: number,
  previousNumber: number | null,
): number | null {
  if (!previousNumber) {
    return null;
  }
  return Math.round(((currentNumber - previousNumber) / previousNumber) * 100);
}

/**
 * Safely parses a float value, returning 0 if the value is invalid or NaN
 */
export function safeParseFloat(value: string | undefined | null): number {
  const parsed = parseFloat(value || "0");
  return Number.isNaN(parsed) ? 0 : parsed;
}

/**
 * Safely parses an integer value, returning 0 if the value is invalid or NaN
 */
export function safeParseInt(value: string | undefined | null): number {
  const parsed = parseInt(value || "0", 10);
  return Number.isNaN(parsed) ? 0 : parsed;
}
